import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationHistoryQueryKey } from '@/features/notification-history/api/use-notification-history-query';
import { artiaProtectedApi } from '@/lib/api-client';

const clearNotificationHistory = async (): Promise<void> => {
  await artiaProtectedApi.post('admin/notification-history/clear');
};

export const useClearNotificationHistory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: clearNotificationHistory,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: notificationHistoryQueryKey });
    }
  });
};
